<!--
  `w-full`, NOT Bootstrap's `w-100` (Bug #234). bootstrap.min.css is loaded globally before styles.scss and
  every one of its utilities carries `!important`, so `w-100` painted `width: 100% !important` no matter what
  Tailwind emitted. Same declared width, but now it is the class it looks like.
-->
<div [ngClass]="{
    'employee-header-background': DarkMode
}" class="w-full">
  <div>
    @if (OldPasswordEntry) {
      <label [ngClass]="{
        'text-gray-900': !DarkMode,
        'text-gray-100': DarkMode
        }" class="block text-sm font-medium leading-6" for="old">Altes Passwort</label>
      <div class="relative mt-2 rounded-md shadow-sm">
        <input (change)="Validate()" [(ngModel)]="PasswordUtil.old" aria-invalid="true" class="text-gray-900 px-2 block w-full rounded-md border-0 py-1.5 pr-10 ring-1 ring-inset focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6" id="old"
               name="old"
               type="password">
      </div>
    }
    <label [ngClass]="{
        'text-gray-900': !DarkMode,
        'text-gray-100': DarkMode
        }" class="text-sm font-medium leading-6 text-gray-900 mt-2 flex" for="password">
      Passwort
      <span (mousedown)="password.type = 'text'"
            (mouseleave)="password.type = 'password'"
            (mouseup)="password.type = 'password'" [ngClass]="{'text-gray-600 hover:text-gray-500': !DarkMode }"
            class="ml-auto fw-light text-gray-200 hover:text-gray-100 select-none cursor-pointer flex">
                @if (password.type == 'password') {
                <svg class="pr-2 place-self-center bi bi-eye-slash" height="24" viewBox="0 0 16 16"
                     width="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
                  <path
                    d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
                  <path
                    d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
                </svg>
                }
                @if (password.type == 'text') {
                <svg class="pr-2 place-self-center bi bi-eye" height="24" viewBox="0 0 16 16"
                     width="24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                </svg>
                }
                <span class="place-self-center">anzeigen</span>
            </span>
    </label>
    <div class="relative mt-2 rounded-md shadow-sm">
      <input #password [(ngModel)]="PasswordUtil.password" (change)="Validate()" (ngModelChange)="Validate()" [ngClass]="{'focus:ring-red-500 ring-red-300': !CheckAll()}"
             aria-invalid="true"
             class="px-2 block w-full rounded-md border-0 py-1.5 pr-10 ring-1 ring-inset focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 text-gray-900"
             id="password"
             name="password" type="password">
      @if (!CheckAll()) {
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <svg aria-hidden="true" class="h-5 w-5 text-red-500" viewBox="0 0 20 20">
            <path clip-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z"
                  fill-rule="evenodd"/>
          </svg>
        </div>
      }
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 text-gray-500">
      <p class="mt-2 text-sm text-gray-500 inline-flex">
        <app-cross-check-display [DarkMode]="DarkMode" [IconSide]="Side.Left" [Text]="'Großbuchstabe'"
                                 [Valid]="CheckUpper()"/>
      </p>
      <p class="mt-2 text-sm text-gray-500 sm:text-right">
        <app-cross-check-display [DarkMode]="DarkMode" [IconSide]="Side.Right" [Text]="'Kleinbuchstabe'"
                                 [Valid]="CheckLower()" class="hidden sm:block"/>
        <app-cross-check-display [DarkMode]="DarkMode" [IconSide]="Side.Left" [Text]="'Kleinbuchstabe'"
                                 [Valid]="CheckLower()" class="sm:hidden"/>
      </p>
      <p class="mt-2 text-sm text-gray-500">
        <app-cross-check-display [DarkMode]="DarkMode" [IconSide]="Side.Left" [Text]="'Zahl'" [Valid]="CheckNumbers()"/>
      </p>
      <p class="mt-2 text-sm text-gray-500 sm:text-right">
        <app-cross-check-display [DarkMode]="DarkMode" [IconSide]="Side.Right" [Text]="'Sonderzeichen:&nbsp;!@#$&*'"
                                 [Valid]="CheckSpecial()" class="hidden sm:block"/>
        <app-cross-check-display [DarkMode]="DarkMode" [IconSide]="Side.Left" [Text]="'Sonderzeichen:&nbsp;!@#$&*'"
                                 [Valid]="CheckSpecial()" class="sm:hidden"/>
      </p>
      <p class="mt-2 text-sm text-gray-500">
        <app-cross-check-display [DarkMode]="DarkMode" [IconSide]="Side.Left" [Text]="'8-32&nbsp;Zeichen'"
                                 [Valid]="CheckLength()"/>
      </p>
    </div>
  </div>
  <label [ngClass]="{
    'text-gray-900': !DarkMode,
    'text-gray-100': DarkMode
    }" class="block text-sm font-medium leading-6 pt-2" for="confirmation">Passwort wiederholen</label>
  <div class="relative mt-2 rounded-md shadow-sm">
    <input [(ngModel)]="PasswordUtil.confirmation" (change)="Validate()" (ngModelChange)="Validate()" [ngClass]="{'focus:ring-red-500 ring-red-300': !CompareConfirmation()}"
           aria-invalid="true"
           class="text-gray-900 px-2 block w-full rounded-md border-0 py-1.5 pr-10 ring-1 ring-inset focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
           id="confirmation"
           name="confirmation" type="password">
    @if (!CompareConfirmation()) {
      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <svg aria-hidden="true" class="h-5 w-5 text-red-500" viewBox="0 0 20 20">
          <path clip-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z"
                fill-rule="evenodd"/>
        </svg>
      </div>
    }
  </div>
  <div [class.opacity-0]="CompareConfirmation()" class="grid grid-cols-1 sm:grid-cols-2 text-gray-500 select-none">
    <p class="mt-2 text-sm inline-flex text-red-500">Passwörter sind nicht gleich</p>
  </div>
</div>
